import dayjs from 'dayjs';
import { DATEFORMAT_LOCAL_STATE } from '@ps20-frontend/utils';
import { Selbstbeteiligung, Zahlungsart, Zahlweise } from '@ps20/bff-models';
import { IAppState } from './appState';

export const INITIAL_STATE: IAppState = {
  version: 10,
  antragsnummer: null,
  versicherungsnehmer: {
    geburtsdatum: null,
    familienstand: null,
    isAssekuranztarif: false,
  },
  transientState: {
    zurueckZumShopModalOpen: false,
    tarifierungIsInProgress: false,
    fehlerCodeTaas: '',
    priceGuarantee: false,
    role: null,
    vorvertragVorschaeden: null,
    featureToggles: {},
    regexps: {},
    kooperationen: null,
  },
  vorbelegungen: {
    versicherungsnehmerVorbelegt: false,
    adresseImmobilieVorbelegt: false,
  },
  risikoort: {
    plz: '',
    ort: '',
    strasse: '',
    hausnummer: '',
  },
  adressvorschlag: {
    orte: [],
    strassen: [],
    lastError: null,
  },
  produkt: null,
  taasInfo: {
    hashedTaasRequest: '',
    hashedRiskData: '',
    rbdNachlass: 0,
    tbNachlass: 0,
    aktionsnachlass: 0,
    savedRbdNachlass: 0,
    savedTbNachlass: 0,
    savedAktionsnachlass: 0,
  },
  jahresbeitrag: 0,
  gesamtbeitrag: 0,
  gesamtbeitragMitRabatt: 0,
  savedGesamtbeitragMitRabatt: 0,
  savedJahresbeitragMitRabatt: 0,
  vertragsoptionen: {
    selbstbeteiligung: Selbstbeteiligung.SELBSTBETEILIGUNG_0000,
    zahlungsweise: Zahlweise.MONATLICH,
    vertragslaufzeit: 3,
    ausgewaehltevertragslaufzeit: 3,
    zahlungsart: Zahlungsart.LASTSCHRIFT,
    beginnDatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    aenderungdatum: dayjs().add(1, 'd').format(DATEFORMAT_LOCAL_STATE),
    vorversicherungVorhanden: true,
    isWeitererVertrag: false,
  },
  anzahlWohnungen: 1,
  vorschaeden: {
    vorhanden: null,
    phVorschaeden: 0,
  },
  rabattstufe: 0,
};
